<div class="aside_title-section">
  <h1 class="title-dashboard">
    {{ 'POI.MOST_ACTIVE_LANDMARKS' | translate }}
  </h1>
</div>
@if (permissionService.checkPermissionValue({ permission: 'READ', tab: 'poi' })) {
  <div class="widget-content-height">
    @if ($activeLandmarks() && $devicesMap()) {
      @if ($activeLandmarks()?.length) {
        @for (landmark of $activeLandmarks(); track landmark; let index = $index) {
          @if (isDashboard ? index < 5 : index < 3) {
            <div style="padding-bottom: 0.5rem; cursor: pointer">
              <landmark-card
                (click)="navigateToLandmark(landmark.uid, landmark.uid_parent)"
                [landmark]="landmark"
                [isDisplayDevices]="true" />
            </div>
          }
        }
      } @else {
        <div class="missing-data-dashboard">
          <p>{{ 'POI.NO_LANDMARK_USED' | translate }}</p>
        </div>
      }
    } @else {
      <widget-loader />
    }
  </div>
  @if ((isDashboard && $activeLandmarks()?.length > 5) || (!isDashboard && $activeLandmarks()?.length > 3)) {
    <div class="data-more-icon">
      <mat-icon (click)="goToPoiActive()" [matTooltip]="'COMMON.SEEMORE' | translate">more_horiz</mat-icon>
    </div>
  }
} @else {
  <p class="not-allowed-text">
    {{ 'USER.NOT_ACCESS_DATA' | translate }}
    <br />
    {{ 'USER.PLEASECONTACTADMIN' | translate }}
  </p>
}
